import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { startCompactMode } from "./styles/compact-mode.ts";

const container = document.getElementById("app-root") ?? document.body;
const root = createRoot(container);

async function loadCSS() {
  if (import.meta.env.DEV) {
    await Promise.all([
      import("./normalize.css"),
      import("./assets/fonts/proximanova.css"),
    ]).catch((error) => {
      console.error("Failed to load CSS in development", error);
    });
  }
}

/**
 * In development, load the config from the server.
 *
 * In production, the config is injected in the HTML.
 */
async function loadConfig() {
  if (import.meta.env.DEV) {
    return import("./load-config-in-dev.js")
      .then(({ loadDevConfig }) => loadDevConfig())
      .catch((error) => {
        console.error("Failed to load config in development:", error);
      });
  }
}

function render() {
  // Before the first render, so no grid mounts in the wrong layout.
  startCompactMode(window, document);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

async function main() {
  await Promise.all([loadCSS(), loadConfig()]);

  render();
}

main().catch((error) => {
  console.error("Failed to start the app", error);
});
